<template>
    <div>

        <form-progress /> 
        
        <div 
        class="row mt-5"
        v-if="section">

            <div class="col-md-4">

                <transition-group 
                tag="ul"
                class="list-group mb-4"
                name="slide-fade">
                    
                    <li class="list-group-item" 
                    :key="item.id"
                    :class="{active: item.id == section.id}"
                    @click="setSection(item.id)"
                    v-for="item in sections">
                        {{$trans(item.name)}}

                        <form-progress 
                        class="mt-3"
                        :light="true"
                        theme="bg-primary-desat"
                        :section="item.id" />

                    </li> <!-- /.list-group-item -->

                </transition-group>

            </div> <!-- /.col -->
            

            <div class="col-md-8">
                
                <div class="row">
                    <form-row 
                    v-for="row in rows"
                    :key="'row-'+row.id" 
                    :row="row" />
                </div> <!-- /.row -->


                <transition-group name="slide-fade">
                    <form-section
                    :key="section.id"
                    :section="section" />
                </transition-group>


                <div class="mt-8 d-flex justify-content-between">

                    <button 
                    key="btn-prev"
                    :disabled="_.first(sections).id == section.id"
                    @click="prevSection()"
                    class="btn btn-outline-primary">
                        Précédant
                    </button>

                    <loading-button 
                    :loading="loading"
                    :disabled="stop || progress.percentage != 100"
                    v-if="_.last(sections).id == section.id"
                    @click="submit()"
                    class="d-inline-block btn btn-primary">
                        Envoyer
                    </loading-button>

                    <button 
                    v-else
                    :disabled="stop"
                    @click="nextSection()"
                    class="d-inline-block btn btn-primary">
                        Suivant
                    </button>

                </div> <!-- /.d-flex -->

            </div> <!-- /.col -->

        </div> <!-- /.row -->

    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        data() {
            return {
                loading: false,
                section: null
            }
        },

        computed: {

            _() {
                return _;
            },
            
            index() {
                return _.findIndex(this.sections, s => s.id == this.section.id )
            },

            ...mapGetters('form', [
                'rows',
                'sections',
                'stop',
                'progress'
            ])
        },

        methods: {
            
            setSection(id) {

                this.section = _.find(
                    this.sections, 
                    section => section.id == id
                )
            },

            prevSection() {
                this.section = this.sections[this.index - 1]
            },

            nextSection() {
                this.section = this.sections[this.index + 1]
            },

            submit() {
                this.loading = true

                this.$store
                .dispatch('form/submitForm')
                .then(() => { this.loading = false })
            }
        },

        mounted() {
            this.section = _.first(this.sections)
        }
        

    }

</script>